export default {
    setCookie: function(cname: string, cvalue: string, exdays: number) {
        //cname = this.view + cname
        var exdays = exdays || 1
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      },
      getCookie: function(cname: string) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length).replace("null", "");
            }
        }
        return "";
    },
    deleteCookie: function(cname: string) {
      var expires = "expires=Thu, 01 Jan 1970 00:00:01 GMT"
      document.cookie = cname + "=" + "cvalue"+ ";" + expires + ";path=/";
    }
  }
  